import { v4 as uuidv4 } from "uuid";
import { Constants } from "../Constants";
import { LocalStorageKey } from "../LocalStorageKey";
import axios, { AxiosRequestConfig } from "axios";
import { TelemetryEvent } from "./TelemetryEvent";
import { getExperimentConfig } from "../../hooks/useExperiment";
const sourceParamKey = "s";

const getClientId = (): string => {
    if (typeof window !== "undefined") {
        const clientId = window.localStorage.getItem(LocalStorageKey.ClientId) ?? uuidv4();
        window.localStorage.setItem(LocalStorageKey.ClientId, clientId);
        return clientId;
    }
    return "";
};

class Telemetry {
    public ClientId: string;
    public InitId: string;

    public constructor() {
        this.InitId = uuidv4();
        this.ClientId = getClientId();
        this.logInit();
    }

    public Log = (event: TelemetryEvent, data: any = null) => {
        this.sendTelemetry(event, data);
    };

    private logInit = () => {
        if (typeof window !== "undefined") {
            const data = { referrer: window.document.referrer, experiment: getExperimentConfig() };
            this.sendTelemetry(TelemetryEvent.AppInit, data);
            this.logSource();
        }
    };

    private sendTelemetry = async (event: TelemetryEvent, payload: any) => {
        const request = axios.post(
            `${Constants.ApiRoot}/telemetry`,
            { _initId: this.InitId, _clientId: this.ClientId, event, data: payload },
            this.getConfig()
        );

        const { data } = await request;
        return data;
    };

    private logSource = () => {
        const params = new URL(document.location.toString()).searchParams;
        const data = params.get(sourceParamKey);
        if (data !== null) {
            this.sendTelemetry(TelemetryEvent.AppAquisitionSource, data);
        }
    };

    private getConfig = (): AxiosRequestConfig => {
        if (typeof window === "undefined") {
            return {};
        }
        const token = window.localStorage.getItem(LocalStorageKey.AuthToken);
        return { headers: { Authorization: `Bearer ${token}`, "x-clientId": this.ClientId, "x-initId": this.InitId } };
    };
}
export const telemetry = new Telemetry();
